import script from "./TransferForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferForm.vue?vue&type=script&lang=ts&setup=true"

import "./TransferForm.vue?vue&type=style&index=0&id=26b7aad6&lang=scss"

const __exports__ = script;

export default __exports__